<template>
  <!-- Main -->
  <div id="main" v-if="initialized">
    <!-- 進階 -->
    <div id="mainAdvanced">
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <EditBoxBoolean
                :code="'is_calorie'"
                :name="$t('AccountSettingAdvance.Commodity_Calories')"
                :value="data.is_calorie"
                :dbTable="'business'"
                :key="'is_calorie'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_rebuild'"
                :name="$t('AccountSettingAdvance.Order_Again')"
                :value="data.is_rebuild"
                :dbTable="'business'"
                :key="'is_rebuild'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_groupbuy'"
                :name="$t('AccountSettingAdvance.Group_Order')"
                :value="data.is_groupbuy"
                :dbTable="'business'"
                :key="'is_groupbuy'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_auto_restore_stock'"
                :name="$t('AccountSettingAdvance.Auto_Restock_Cancellation')"
                :value="data.is_auto_restore_stock"
                :dbTable="'business'"
                :key="'is_auto_restore_stock'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_manual'"
                :name="$t('AccountSettingAdvance.Manual_Accept_Order')"
                :value="data.is_manual"
                :dbTable="'accounts'"
                :key="'is_manual'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_pick_up'"
                :name="$t('AccountSettingAdvance.Show_Order_Page_Shipping_Cup')"
                :value="data.is_pick_up"
                :dbTable="'business'"
                :key="'is_pick_up'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_invoice'"
                :name="$t('AccountSettingAdvance.Show_Uniform_Number_Field')"
                :value="data.is_invoice"
                :dbTable="'business'"
                :key="'is_invoice'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_carrier'"
                :name="$t('AccountSettingAdvance.Show_Mobile_Carrier_Field')"
                :value="data.is_carrier"
                :dbTable="'business'"
                :key="'is_carrier'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_receipt'"
                :name="$t('AccountSettingAdvance.Provide_Receipt')"
                :value="data.is_receipt"
                :dbTable="'business'"
                :key="'is_receipt'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_otp_enabled'"
                :name="$t('AccountSettingAdvance.Enable_Online_Order_SMS_Verification')"
                :value="data.is_otp_enabled"
                :dbTable="'business'"
                :key="'is_otp_enabled'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_email'"
                :name="$t('AccountSettingAdvance.Is_Email_Required')"
                :value="data.is_email"
                :dbTable="'business'"
                :key="'is_email'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_not_comment_of_order_display'"
                :name="$t('AccountSettingAdvance.Show_Order_Note_Field')"
                :value="!data.is_not_comment_of_order_display"
                :dbTable="'business'"
                :key="'is_not_comment_of_order_display'"
                @toggle-switch="toggleReverseSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_not_comment_of_delivery_display'"
                :name="$t('AccountSettingAdvance.Show_Delivery_Note_Field')"
                :value="!data.is_not_comment_of_delivery_display"
                :dbTable="'business'"
                :key="'is_not_comment_of_delivery_display'"
                @toggle-switch="toggleReverseSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_not_comment_product_display'"
                :name="$t('AccountSettingAdvance.Show_Commodity_Note_Field')"
                :value="!data.is_not_comment_product_display"
                :dbTable="'business'"
                :key="'is_not_comment_product_display'"
                @toggle-switch="toggleReverseSwitch($event)"
              />
            </div>
            <div class="item">
              <EditBoxBoolean
                :code="'is_line_item'"
                :name="$t('AccountSettingAdvance.Line_Item_Mode')"
                :value="data.is_line_item"
                :dbTable="'business'"
                :key="'is_line_item'"
                @toggle-switch="toggleSwitch($event)"
              />
            </div>
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.Rounding_method') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: data.carry_method === 'round'}" @click="changeRoundingMethod('round')">
                  <span>{{ $t('AccountSettingAdvance.round') }}</span>
                </a>
                <a class="tab" :class="{active: data.carry_method === 'floor'}" @click="changeRoundingMethod('floor')">
                  <span>{{ $t('AccountSettingAdvance.floor') }}</span>
                </a>
                <a class="tab" :class="{active: data.carry_method === 'ceil'}" @click="changeRoundingMethod('ceil')">
                  <span>{{ $t('AccountSettingAdvance.ceil') }}</span>
                </a>
               
              </div>
            </div>
            <!-- 自助結帳供應商-->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.billingAutomation.vendor') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: billingAutomationVendor === 'qrs'}" @click="changeNestedAccountSettings('billingAutomation.vendor', 'qrs' )">
                  <span> {{ $t('AccountSettingAdvance.billingAutomation.qrs') }} </span>
                </a>
                <a class="tab" :class="{active: billingAutomationVendor === 'ddba'}" @click="changeNestedAccountSettings('billingAutomation.vendor', 'ddba' )">
                  <span> DDBA </span>
                </a>
                <a class="tab" :class="{active: billingAutomationVendor === 'external'}" @click="changeNestedAccountSettings('billingAutomation.vendor', 'external')">
                  <span>{{ $t('AccountSettingAdvance.billingAutomation.external') }}</span>
                </a>
              </div>
            </div>
            <!-- 支援CRM累積點數提醒-->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.crm.accumulatedPointReminder') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: accountOptions.crm.accumulatedPointReminder}" @click="changeNestedAccountSettings('crm.accumulatedPointReminder', true)">
                  <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                </a>
                <a class="tab" :class="{active: !accountOptions.crm.accumulatedPointReminder}" @click="changeNestedAccountSettings('crm.accumulatedPointReminder', false)">
                  <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                </a>
              </div>
            </div>
            <!-- 支援現場點餐需要會員登入-->
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">{{ $t('AccountSettingAdvance.loginRequired.onsiteOrder') }}</span>
                <span class="remark"> {{ $t('AccountSettingAdvance.loginRequired.reminder') }} </span>
              </div>
              <div class="tabs" style="margin-left: 10px;">
                  <a class="tab" :class="{active: accountOptions.loginRequired && accountOptions.loginRequired.eatIn}" @click="changeNestedAccountSettings('loginRequired.eatIn', true)">
                    <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                  </a>
                  <a class="tab" :class="{active: !(accountOptions.loginRequired && accountOptions.loginRequired.eatIn)}" @click="changeNestedAccountSettings('loginRequired.eatIn', false)">
                    <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                  </a>
                </div>

            </div>

             <!-- 支援自取點餐需要會員登入-->
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">{{ $t('AccountSettingAdvance.loginRequired.togoOrder') }}</span>
              </div>
              <div class="tabs" style="margin-left: 10px;">
                  <a class="tab" :class="{active: accountOptions.loginRequired && accountOptions.loginRequired.togo}" @click="changeNestedAccountSettings('loginRequired.togo', true)">
                    <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                  </a>
                  <a class="tab" :class="{active: !(accountOptions.loginRequired && accountOptions.loginRequired.togo)}" @click="changeNestedAccountSettings('loginRequired.togo', false)">
                    <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                  </a>
                </div>

            </div>

             <!-- 支援外送點餐需要會員登入-->
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <span class="content">{{ $t('AccountSettingAdvance.loginRequired.deliveryOrder') }}</span>
              </div>
              <div class="tabs" style="margin-left: 10px;">
                  <a class="tab" :class="{active: accountOptions.loginRequired && accountOptions.loginRequired.delivery}" @click="changeNestedAccountSettings('loginRequired.delivery', true)">
                    <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                  </a>
                  <a class="tab" :class="{active: !(accountOptions.loginRequired && accountOptions.loginRequired.delivery)}" @click="changeNestedAccountSettings('loginRequired.delivery', false)">
                    <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                  </a>
                </div>

            </div>

            <!-- dummy item -->
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>            
            <div class="item"></div>

          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="content">QC1.0 {{ $t('AccountSettingAdvance.Menu_Style') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: data.is_new_style}" @click="changeMenuStyle('single', '1.0')">
                  <div class="icon">
                    <FontAwesomeIcon icon="list-ul"/>
                  </div>
                  <span>{{ $t('AccountSettingAdvance.Single_Column') }}</span>
                </a>
                <a class="tab" :class="{active: !data.is_new_style}" @click="changeMenuStyle('double', '1.0')">
                  <div class="icon">
                    <FontAwesomeIcon icon="columns"/>
                  </div>
                  <span>{{ $t('AccountSettingAdvance.Double_Column') }}</span>
                </a>
              </div>
            </div>
            <div class="item">
              <span class="content">QC2.0 {{ $t('AccountSettingAdvance.Menu_Style') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: data.qc2_menu_style==='single'}" @click="changeMenuStyle('single', '2.0')">
                  <div class="icon">
                    <FontAwesomeIcon icon="list-ul"/>
                  </div>
                  <span>{{ $t('AccountSettingAdvance.Single_Column') }}</span>
                </a>
                <a class="tab" :class="{active: data.qc2_menu_style==='double'}" @click="changeMenuStyle('double', '2.0')">
                  <div class="icon">
                    <FontAwesomeIcon icon="columns"/>
                  </div>
                  <span>{{ $t('AccountSettingAdvance.Double_Column') }}</span>
                </a>
              </div>
            </div>
            <div class="item">
              <span class="content">QC3.0 {{ $t('AccountSettingAdvance.Menu_Style') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: data.qc3_menu_style==='single'}" @click="changeMenuStyle('single', '3.0')">
                  <div class="icon">
                    <FontAwesomeIcon icon="list-ul"/>
                  </div>
                  <span>{{ $t('AccountSettingAdvance.Single_Column') }}</span>
                </a>
                <a class="tab" :class="{active: data.qc3_menu_style==='double'}" @click="changeMenuStyle('double', '3.0')">
                  <div class="icon">
                    <FontAwesomeIcon icon="columns"/>
                  </div>
                  <span>{{ $t('AccountSettingAdvance.Double_Column') }}</span>
                </a>
              </div>
            </div>
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.Default_Meal_Type') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: data.default_meal_type === 'eat_in'}" @click="changeDefaultMealType('eat_in')">
                  <span>{{ $t('AccountSettingStore.Dine_In') }}</span>
                </a>
                <a class="tab" :class="{active: data.default_meal_type === 'to_go'}" @click="changeDefaultMealType('to_go')">
                  <span>{{ $t('AccountSettingStore.Self_Pickup') }}</span>
                </a>
                <a class="tab" :class="{active: data.default_meal_type === 'delivery'}" @click="changeDefaultMealType('delivery')">
                  <span>{{ $t('AccountSettingStore.Delivery') }}</span>
                </a>
                <a class="tab" :class="{active: data.default_meal_type === 'none'}" @click="changeDefaultMealType('none')">
                  <span>{{ $t('AccountSettingAdvance.None') }}</span>
                </a>
              </div>
            </div>
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.PDG_Mode') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: data.pdg_mode === '1.0'}" @click="changePDGMode('1.0')">
                  <span> 1.0 </span>
                </a>
                <a class="tab" :class="{active: data.pdg_mode === '2.0'}" @click="changePDGMode('2.0')">
                  <span> 2.0 </span>
                </a>
              </div>
            </div>
            <!-- 後結版本 -->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.checkout_version') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: !data.post_pay_workflow}" @click="changeCheckoutVersion()">
                  <span> 1.0 </span>
                </a>
                <a class="tab" :class="{active: data.post_pay_workflow}" @click="changeCheckoutVersion(defaultPostPayWorkflow)">
                  <span> 3.0 ({{$t('AccountSettingAdvance.emenu')}})</span>
                </a>
              </div>
            </div>
            <!-- 現場結帳模式 -->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.onsite_checkout_mode') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: onsiteCheckoutMode !== 'PREPAY'}" @click="changeOnsiteCheckoutMode('QUICK')">
                  <span> {{ $t('AccountSettingAdvance.Onsite_Payment_Type.QUICK') }} </span>
                </a>
                <a class="tab" :class="{active: onsiteCheckoutMode === 'PREPAY'}" @click="changeOnsiteCheckoutMode('PREPAY')">
                  <span>{{ $t('AccountSettingAdvance.Onsite_Payment_Type.PREPAY') }}</span>
                </a>
              </div>
            </div>
            <!-- 列印出帳單-->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.Is_Print_Checkout_Enabled') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: isPrintCheckoutEnabled}" @click="changeAccountsOptions(true, 'isPrintCheckoutEnabled')">
                  <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                </a>
                <a class="tab" :class="{active: !isPrintCheckoutEnabled}" @click="changeAccountsOptions(false, 'isPrintCheckoutEnabled')">
                  <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                </a>
              </div>
            </div>
            <!-- 現場結帳後發WEBHOOK-->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.Webhook_After_Onsite_Checkout') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: integrationMode}" @click="changeIntegrationMode('AfterAccepted')">
                  <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                </a>
                <a class="tab" :class="{active: !integrationMode}" @click="changeIntegrationMode()">
                  <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                </a>
              </div>
            </div>
            <!-- 餐具選擇自動加到訂單備註-->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.Disposable_Items_2_Instruction') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: disposableItems2Instruction}" @click="changeAccountsOptions(true, 'disposableItems2Instruction')">
                  <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                </a>
                <a class="tab" :class="{active: !disposableItems2Instruction}" @click="changeAccountsOptions(false, 'disposableItems2Instruction')">
                  <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                </a>
              </div>
            </div>
            <!-- Foodpanda 二層式套餐選項 -->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.Two_Level_Foodpanda_Meal_Selection') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: nestedCartTransformer}" @click="changeAccountsOptions(true, 'nestedCartTransformer')">
                  <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                </a>
                <a class="tab" :class="{active: !nestedCartTransformer}" @click="changeAccountsOptions(false, 'nestedCartTransformer')">
                  <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                </a>
              </div>
            </div>
            <!-- 顯示支付別/狀態 -->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.kiosk_Custom_Setting') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: kioskCustomSetting}" @click="changeAccountsOptions(true, 'kioskCustomSetting')">
                  <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                </a>
                <a class="tab" :class="{active: !kioskCustomSetting}" @click="changeAccountsOptions(false, 'kioskCustomSetting')">
                  <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                </a>
              </div>
            </div>
            <!-- 外帶自取參數相容-->
            <div class="item">
              <span class="content">{{ $t('AccountSettingAdvance.Takeaway_2_Togo') }}</span>
              <div class="tabs" style="margin-left: 10px;">
                <a class="tab" :class="{active: takeaway2Togo}" @click="changeAccountsOptions(true, 'takeaway2Togo')">
                  <span> {{ $t('AccountSettingAdvance.Enabled') }} </span>
                </a>
                <a class="tab" :class="{active: !takeaway2Togo}" @click="changeAccountsOptions(false, 'takeaway2Togo')">
                  <span>{{ $t('AccountSettingAdvance.Disabled') }}</span>
                </a>
              </div>
            </div>
            <EditBoxInput
              :code="'start_number'"
              :name="$t('AccountSettingAdvance.Custom_Order_Serial_Number')"
              :dbTable="'business'"
              :key="'start_number'"
              v-model="data.start_number"
              :placeholder="$t('AccountSettingAdvance.Custom_Order_Serial_Number')"
              :remark="$t('AccountSettingAdvance.Please_Enter_Number')"
              :dtype="'number'"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'buffer_time'"
              :name="$t('AccountSettingAdvance.Pickup_Buffer_Time')"
              :dbTable="'business'"
              :key="'buffer_time'"
              v-model="data.buffer_time"
              :placeholder="$t('AccountSettingAdvance.Pickup_Buffer_Time')"
              :remark="$t('AccountSettingAdvance.Set_To_0_To_Hide')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'reset_time'"
              :name="$t('AccountSettingAdvance.Shelf_Reset_Time_For_On_Sale_Items')"
              :dbTable="'business'"
              :key="'reset_time'"
              v-model="data.reset_time"
              :placeholder="$t('AccountSettingAdvance.Shelf_Reset_Time_For_On_Sale_Items')"
              :remark="'hh:mm'"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'amount'"
              :name="$t('AccountSettingAdvance.High_Order_Amount_Limit')"
              :dbTable="'large_order'"
              :key="'amount'"
              v-model="data.amount"
              :placeholder="$t('AccountSettingAdvance.High_Order_Amount_Limit')"
              :remark="$t('AccountSettingAdvance.Please_Enter_Number_In_Yuan')"
              :dtype="'number'"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'qty'"
              :name="$t('AccountSettingAdvance.High_Order_Quantity_Limit')"
              :dbTable="'large_order'"
              :key="'qty'"
              v-model="data.qty"
              :placeholder="$t('AccountSettingAdvance.High_Order_Quantity_Limit')"
              :remark="$t('AccountSettingAdvance.Please_Enter_Number')"
              :dtype="'number'"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <!-- 電子菜單顏色 主色 -->
            <EditBoxInput
              :code="'primary'"
              :name="$t('AccountSettingAdvance.Primary_Color')"
              :dbTable="'accounts'"
              :key="'primary'"
              v-model="accountOptions.style.color.primary"
              :placeholder="$t('AccountSettingAdvance.Primary_Color')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <!-- 電子菜單顏色 副色 -->
            <EditBoxInput
              :code="'secondary'"
              :name="$t('AccountSettingAdvance.Secondary_Color')"
              :dbTable="'accounts'"
              :key="'secondary'"
              v-model="accountOptions.style.color.secondary"
              :placeholder="$t('AccountSettingAdvance.Secondary_Color')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <!-- 電子菜單顏色 主题 -->
            <EditBoxInput
              :code="'themeMode'"
              :name="$t('AccountSettingAdvance.Theme_Mode')"
              :dbTable="'accounts'"
              :key="'themeMode'"
              v-model="accountOptions.style.themeMode"
              :placeholder="$t('AccountSettingAdvance.Theme_Mode')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
              :code="'logo'"
              :name="'Logo'"
              :dbTable="'business'"
              :key="'logo'"
              v-model="data.logoUrl"
              :placeholder="''"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
            <EditBoxInput
            :code="'favicon'"
            :name="'favicon'"
            :dbTable="'business'"
            :key="'favicon'"
            v-model="data.faviconUrl"
            :placeholder="''"
            @update-input="updateInput($event)"
            @change-edit-status="changeEditStatus($event)"
          />
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">{{ `${$t('AccountSettingAdvance.Dine_In_Announcement_Setting')} - ${$t('AccountSettingAdvance.On_Site_Payment')}` }}</span>
            <EditBoxTextareaHtml
              :code="'offline_eat_in_notice'"
              :name="$t('AccountSettingAdvance.Dine_In_On_Site_Payment_Announcement')"
              :dbTable="'business'"
              :key="'offline_eat_in_notice'"
              v-model="data.offline_eat_in_notice"
              :placeholder="$t('AccountSettingAdvance.Please_Enter_Dine_In_On_Site_Payment_Announcement')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <span class="title">{{ `${$t('AccountSettingAdvance.Dine_In_Announcement_Setting')} - ${$t('AccountSettingAdvance.Online_Payment')}` }}</span>
            <EditBoxTextareaHtml
              :code="'online_eat_in_notice'"
              :name="$t('AccountSettingAdvance.Dine_In_Online_Payment_Announcement')"
              :dbTable="'business'"
              :key="'online_eat_in_notice'"
              v-model="data.online_eat_in_notice"
              :placeholder="$t('AccountSettingAdvance.Please_Enter_Dine_In_Online_Payment_Announcement')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">{{ `${$t('AccountSettingAdvance.Self_Pickup_Announcement_Setting')} - ${$t('AccountSettingAdvance.On_Site_Payment')}` }}</span>
            <EditBoxTextareaHtml
              :code="'offline_to_go_notice'"
              :name="$t('AccountSettingAdvance.Self_Pickup_On_Site_Payment_Announcement')"
              :dbTable="'business'"
              :key="'offline_to_go_notice'"
              v-model="data.offline_to_go_notice"
              :placeholder="$t('AccountSettingAdvance.Please_Enter_Self_Pickup_On_Site_Payment_Announcement')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <span class="title">{{ `${$t('AccountSettingAdvance.Self_Pickup_Announcement_Setting')} - ${$t('AccountSettingAdvance.Online_Payment')}` }}</span>
            <EditBoxTextareaHtml
              :code="'online_to_go_notice'"
              :name="$t('AccountSettingAdvance.Self_Pickup_Online_Payment_Announcement')"
              :dbTable="'business'"
              :key="'online_to_go_notice'"
              v-model="data.online_to_go_notice"
              :placeholder="$t('AccountSettingAdvance.Please_Enter_Self_Pickup_Online_Payment_Announcement')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">{{ `${$t('AccountSettingAdvance.Delivery_Announcement_Setting')} - ${$t('AccountSettingAdvance.On_Site_Payment')}` }}</span>
            <EditBoxTextareaHtml
              :code="'offline_delivery_notice'"
              :name="$t('AccountSettingAdvance.Delivery_On_Site_Payment_Announcement')"
              :dbTable="'business'"
              :key="'offline_delivery_notice'"
              v-model="data.offline_delivery_notice"
              :placeholder="$t('AccountSettingAdvance.Please_Enter_Delivery_On_Site_Payment_Announcement')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <span class="title">{{ `${$t('AccountSettingAdvance.Delivery_Announcement_Setting')} - ${$t('AccountSettingAdvance.Online_Payment')}` }}</span>
            <EditBoxTextareaHtml
              :code="'online_delivery_notice'"
              :name="$t('AccountSettingAdvance.Delivery_On_Site_Payment_Announcement')"
              :dbTable="'business'"
              :key="'online_delivery_notice'"
              v-model="data.online_delivery_notice"
              :placeholder="$t('AccountSettingAdvance.Please_Enter_Delivery_On_Site_Payment_Announcement')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
      </div>
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <span class="title">{{ `${$t('AccountSettingAdvance.Takeaway_Announcement_Setting')} - ${$t('AccountSettingAdvance.On_Site_Payment')}` }}</span>
            <EditBoxTextareaHtml
              :code="'offline_takeaway_notice'"
              :name="$t('AccountSettingAdvance.Takeaway_On_Site_Payment_Announcement')"
              :dbTable="'business'"
              :key="'offline_takeaway_notice'"
              v-model="data.offline_takeaway_notice"
              :placeholder="$t('AccountSettingAdvance.Please_Enter_Takeaway_On_Site_Payment_Announcement')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <span class="title">{{ `${$t('AccountSettingAdvance.Takeaway_Announcement_Setting')} - ${$t('AccountSettingAdvance.Online_Payment')}` }}</span>
            <EditBoxTextareaHtml
              :code="'online_takeaway_notice'"
              :name="$t('AccountSettingAdvance.Takeaway_On_Site_Payment_Announcement')"
              :dbTable="'business'"
              :key="'online_takeaway_notice'"
              v-model="data.online_takeaway_notice"
              :placeholder="$t('AccountSettingAdvance.Please_Enter_Takeaway_On_Site_Payment_Announcement')"
              @update-input="updateInput($event)"
              @change-edit-status="changeEditStatus($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditBoxBoolean from "src/components/GaaConsole/EditBoxBoolean.vue";
import EditBoxInput from "src/components/GaaConsole/EditBoxInput.vue";
import EditBoxTextarea from "src/components/GaaConsole/EditBoxTextarea.vue";
import EditBoxRichEditor from "src/components/GaaConsole/EditBoxRichEditor.vue";
import EditBoxTextareaHtml from "src/components/GaaConsole/EditBoxTextareaHtml.vue";

import {
  updateAccounts,
  updateBusiness,
  updateBusinessInfo,
  updateLargeOrder
} from "src/javascripts/generalPages/updateForConsoleLog";
import { fetchSettings, fetchLargeOrder } from "src/javascripts/generalPages/fetchForConsoleLog";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    EditBoxBoolean,
    EditBoxInput,
    EditBoxTextarea,
    EditBoxRichEditor,
    FontAwesomeIcon,
    EditBoxTextareaHtml
  },
  data() {
    return {
      data: {
        is_calorie: false,
        is_rebuild: false,
        is_groupbuy: false,
        is_auto_restore_stock: false,
        is_manual: false,
        is_enabled: false,
        is_pick_up: false,
        is_invoice: false,
        is_carrier: false,
        is_receipt: false,
        is_otp_enabled: false,
        start_number: 1,
        buffer_time: 0,
        reset_time: "00:00",
        is_new_style: false,
        qc2_menu_style: "single",
        qc3_menu_style: "double",
        default_meal_type: "to_go",
        carry_method: "round",
        pdg_mode: "2.0",
        post_pay_workflow: null,
        logoUrl: "",
        faviconUrl: "",
        options: {
          paymentMode: 'QUICK',
          isPrintCheckoutEnabled: false, 
          integrationMode: null, 
          disposableItems2Instruction: false, 
          nestedCartTransformer: false,
          kioskCustomSetting: false,
          takeaway2Togo: false,
          style: {
            color: {
              primary: "",
              secondary: ""
            },
            themeMode: ""
          },
          billingAutomation: {
            vendor: ""
          },
          crm: {
            accumulatedPointReminder: false
          },
          loginRequired: {
            eatIn: false,
            // takeaway: false, 
            togo: true,
            delivery: true
          }
        },
        amount: 99999,
        qty: 999,
        offline_eat_in_notice: "",
        online_eat_in_notice: "",
        offline_to_go_notice: "",
        online_to_go_notice: "",
        offline_delivery_notice: "",
        online_delivery_notice: "",
        offline_takeaway_notice: "",
        online_takeaway_notice: "",
      },
      initialized: false,
      editList: []
    };
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    }, 
    defaultPostPayWorkflow () {
      return process.env.VUE_APP_POST_PAY_WORKFLOW 
      ? process.env.VUE_APP_POST_PAY_WORKFLOW.trim() 
      : process.env.NODE_ENV === 'production' 
      ? 'qc_printqr_beta'
      : 'qc_printqr_staging' ;
    },
    accountOptions () {
      if (this.data.options) {
        let temp = JSON.parse(this.data.options);
        if (!temp.style) {
          temp.style = {
            color: {
                primary: "",
                secondary: ""
              },
              themeMode: ""
          }
        }
        if (!temp.billingAutomation) {
          temp.billingAutomation = {
            vendor: ""
          }
        }
        if (!temp.crm) {
          temp.crm = {
            accumulatedPointReminder: false
          }
        }
        if (!temp.loginRequired){
          temp.loginRequired = {
            eatIn: false,
            // takeaway: false,
            togo: true,
            delivery: true
          }
        } else {
          // Ensure togo and delivery default to true if not set
          if (temp.loginRequired.togo === undefined) {
            temp.loginRequired.togo = true;
          }
          if (temp.loginRequired.delivery === undefined) {
            temp.loginRequired.delivery = true;
          }
          // Ensure eatIn default to true if not set
          if (temp.loginRequired.eatIn === undefined) {
            temp.loginRequired.eatIn = false;
          }
        }
        return temp;
      } else {
        return {
          style:{
            color: {
                primary: "",
                secondary: ""
              },
              themeMode: ""
          },
          billingAutomation: {
            vendor: "external"
          },
          crm: {
            accumulatedPointReminder: false
          },
          loginRequired : {
            eatIn: false,
            // takeaway: false,
            togo: true,
            delivery: true
          }
        };
      }
    },
    onsiteCheckoutMode() {
      if (this.accountOptions) {
        return this.accountOptions.paymentMode;
      } else {
        return 'QUICK';
      }
    },
    isPrintCheckoutEnabled() {
      if (this.accountOptions) {
        return this.accountOptions.isPrintCheckoutEnabled;
      } else {
        return false;
      }
    },
    disposableItems2Instruction() {
      if (this.accountOptions) {
        return this.accountOptions.disposableItems2Instruction;
      } else {
        return false;
      }
    },
    billingAutomationVendor() {
      if (this.accountOptions && this.accountOptions.billingAutomation) {
        return this.accountOptions.billingAutomation.vendor || 'external';
      } else {
        return 'external';
      }
    },
    nestedCartTransformer() {
      if (this.accountOptions) {
        return this.accountOptions.nestedCartTransformer;
      } else {
        return false;
      }
    },
    kioskCustomSetting() {
      if (this.accountOptions) {
        return this.accountOptions.kioskCustomSetting;
      } else {
        return false;
      }
    },
    takeaway2Togo() {
      if (this.accountOptions) {
        return this.accountOptions.takeaway2Togo;
      } else {
        return false;
      }
    },
    integrationMode() {
      if (this.accountOptions) {
        return this.accountOptions.integrationMode;
      } else {
        return null;
      }
    }
  }, 
  created: function() {
    // fetch value
    fetchSettings(this.accountId, this.$route.params.type)
      .then(fetchSettingsRes => {
        return Promise.all([fetchSettingsRes, fetchLargeOrder(this.accountId, this.$route.params.type)]);
      })
      .then(res => {
        let fetchSettingsRes = res[0];
        let fetchLargeOrderRes = res[1];
        if (fetchSettingsRes.data.length > 0) {
          var settingData = {};
          if(fetchLargeOrderRes.data.length > 0) {
            Object.assign(settingData, fetchSettingsRes.data[0], fetchLargeOrderRes.data[0]);
          } else {
            Object.assign(settingData, fetchSettingsRes.data[0]);
          }
          this.setData(settingData);
        } else {
          throw new Error("FetchData error!");
        }
      })
      .catch(err => {
        console.log("err: ", err);
        this.$message({
          type: "error",
          message: this.$t('AccountSettingAdvance.Message.Failed_to_get_info', { accountId: this.accountId })
        });
      });
  },
  methods: {
    setData(fetchData) {
      for (var prop in fetchData) {
        if (fetchData[prop] === 1) fetchData[prop] = true;
        if (fetchData[prop] === 0) fetchData[prop] = false;
      }
      console.log("fetchData: ", fetchData);
      fetchData = this.initailDataFormating(fetchData);
      this.data = Object.assign(this.data, fetchData);
      this.convertResetTimeToHour();
      this.initialized = true;
    },
    toggleSwitch(event) {
      this.data[event.code] = event.mutation;
      this.data = Object.assign(this.data);

      let updateBooleanData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        label: event.name,
        type: event.type
      };
      this.edit(updateBooleanData);
    },
    toggleReverseSwitch(event) {
      this.data[event.code] = !event.mutation;
      this.data = Object.assign(this.data);

      let updateBooleanData = {
        key: event.code,
        value: !event.mutation,
        dbTable: event.dbTable,
        label: event.name,
        type: event.type
      };
      this.edit(updateBooleanData);
    },
    updateInput(event) {
      let updateInputData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        origin: event.origin,
        label: event.name,
        type: event.type
      };

      if (["primary", "secondary", "themeMode"].includes(event.code)) {
        updateInputData.key = "options";
        updateInputData.type = "content";
        let options = this.accountOptions ? JSON.parse(JSON.stringify(this.accountOptions)) : {};

        if (!options.style) options.style = {};
        if (["primary", "secondary"].includes(event.code) && !options.style.color) options.style.color = {};

        if (["primary", "secondary"].includes(event.code)) {
          options.style.color[event.code] = event.mutation;
        } else if (event.code === "themeMode") {
          options.style[event.code] = event.mutation;
        }

        updateInputData.value = JSON.stringify(options);
      }
      
      this.edit(updateInputData);
    },
    edit(data) {
      let label = data.label;
      if(!this.formatChecking(data)) {
        this.$message({
          type: "error",
          message: this.$t('AccountSettingAdvance.Message.Incorrect_format', { label })
        });
        return;
      }
      if (data.key === "name") data.dbTable = "accounts&business";
      switch (data.dbTable) {
        case "accounts":
          updateAccounts(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business":
          updateBusiness(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business_info":
          updateBusinessInfo(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "accounts&business":
          updateAccounts(data, this.accountId, this.type)
            .then(res => updateBusiness(data, this.accountId, this.type))
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "large_order":
          updateLargeOrder(data, this.accountId, this.type)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        default:
          console.log("undefined db talbe: " + data.dbTable);
          break;
      }
    },
    editSuccess(res, label) {
      console.log(res);
      this.$message({
        type: "success",
        message: this.$t('AccountSettingAdvance.Message.Update_successfully', { label })
      });
      this.$emit('saved', true);
    },
    editError(err) {
      console.log(err);
      this.$message({
        type: "error",
        message: this.$t('AccountSettingAdvance.Message.Update_failed')
      });
    },
    formatChecking(data) {
      let key = data.key;
      let value = data.value;
      switch (key) {
        case "reset_time":
          return this.timeFormatCheck(value);
          break;
        default:
          return true;
          break;
      }
    },
    timeFormatCheck(hhmm) {
      let patt24HourWithLeadingZero = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
      return hhmm ? patt24HourWithLeadingZero.test(hhmm) : true;
    },
    changeMenuStyle(type, platform) {
      let dbTable = "accounts";
      let code = "is_new_style";
      let _type = "boolean";
      const _platformType = platform + "-" + type
      if (platform === '2.0') {
        dbTable = "business";
        code = "qc2_menu_style";
        _type = "string";
      } else if (platform === '3.0') {
        dbTable = "business";
        code = "qc3_menu_style";
        _type = "string";
      }
      switch (_platformType) {
        case "1.0-single":
          this.data.is_new_style = true;
          break;
        case "1.0-double":
          this.data.is_new_style = false;
          break;
        case "2.0-single":
        case "3.0-single":  
          this.data[code] = 'single';
          break;
        case "2.0-double":
        case "3.0-double":  
          this.data[code] = 'double';
          break;
        default:
          break;
      }
      let event = Object.assign({}, {
        mutation: this.data[code],
        code,
        dbTable,
        name: 'QC' + platform + ' ' + this.$t('AccountSettingAdvance.Menu_Style'),
        type: _type
      });
      this.toggleSwitch(event);
      return;
    },
    changeDefaultMealType(type) {
      this.data.default_meal_type  = type
      let event = Object.assign({}, {
        mutation: this.data.default_meal_type,
        code: 'default_meal_type',
        dbTable: 'business',
        name: this.$t('AccountSettingAdvance.Default_Meal_Type'),
        type: 'string'
      });
      this.toggleSwitch(event);
      return;
    },
    changeRoundingMethod(method) {
      this.data.carry_method  = method;
      let event = Object.assign({}, {
        mutation: this.data.carry_method,
        code: 'carry_method',
        dbTable: 'business',
        name: this.$t('AccountSettingAdvance.Rounding_method'),
        type: 'string'
      });
      this.toggleSwitch(event);
      return;
    },
    changePDGMode(mode) {
      this.data.pdg_mode  = mode
      let event = Object.assign({}, {
        mutation: this.data.pdg_mode,
        code: 'pdg_mode',
        dbTable: 'business',
        name: this.$t('AccountSettingAdvance.PDG_Mode'),
        type: 'string'
      });
      this.toggleSwitch(event);
      return;
    },
    changeCheckoutVersion(version) {
      this.data.post_pay_workflow  = version;
      let event = Object.assign({}, {
        mutation: this.data.post_pay_workflow,
        code: 'post_pay_workflow',
        dbTable: 'accounts',
        name: this.$t('AccountSettingAdvance.checkout_version'),
        type: 'string'
      });
      this.toggleSwitch(event);
      return;
    },
    changeOnsiteCheckoutMode(mode) {
      const paymentMode  = mode || 'QUICK';
      let options = null;
      if (this.accountOptions) {
        options = Object.assign (this.accountOptions, {paymentMode});
      } else {
        options = {
          paymentMode 
        }
      }
      let event = Object.assign({}, {
        mutation: JSON.stringify(options),
        code: 'options',
        dbTable: 'accounts',
        name: this.$t('AccountSettingAdvance.onsite_checkout_mode'),
        type: 'content'
      });
      this.toggleSwitch(event);
      return;
    },
    
    
    changeNestedAccountSettings(keys, value) {
      const self = this
      function convertToObject(path, value) {
        const keys = path.split('.'); // Split the path into individual keys
        let result = self.accountOptions ? Object.assign (self.accountOptions, {}) : {};           // Initialize an empty object
        let current = result;        // Reference to the current position in the result object
        keys.forEach((key, index) => {
          // If we're at the last key, assign the value
          if (index === keys.length - 1) {
            current[key] = value;

          } else {
            // Otherwise, create a nested object for the current key if it doesn't exist
            if (!current[key]) {
              current[key] = {};
            }
          }
          current = current[key];    // Move to the next level
        });

        console.log('result:', result)

        return result;  
      }
      
      let options = convertToObject(keys, value);
      let event = Object.assign({}, {
        mutation: JSON.stringify(options),
        code: 'options',
        dbTable: 'accounts',
        name: '', // this.$t('AccountSettingAdvance.Is_Print_Checkout_Enabled'),
        type: 'content'
      });
      this.toggleSwitch(event);
      return;
    },
    changeAccountsOptions(enabled, key) {
      let options = null;
      if (this.accountOptions) {
        options = Object.assign (this.accountOptions, {[key]: enabled || false});
      } else {
        options = {
          [key]: enabled || false
        }
      }
      let event = Object.assign({}, {
        mutation: JSON.stringify(options),
        code: 'options',
        dbTable: 'accounts',
        name: '', // this.$t('AccountSettingAdvance.Is_Print_Checkout_Enabled'),
        type: 'content'
      });
      this.toggleSwitch(event);
      return;
    },
    changeIntegrationMode(mode) {
      const integrationMode = mode || null;
      let options = null;
      if (this.accountOptions) {
        options = Object.assign (this.accountOptions, {integrationMode});
      } else {
        options = {
          integrationMode 
        }
      }
      let event = Object.assign({}, {
        mutation: JSON.stringify(options),
        code: 'options',
        dbTable: 'accounts',
        name: this.$t('AccountSettingAdvance.Webhook_After_Onsite_Checkout'),
        type: 'content'
      });
      this.toggleSwitch(event);
      return;
    },
    convertResetTimeToHour() {
      let resetTime = this.data.reset_time;
      let resetTimeHour = resetTime? resetTime.slice(0, 3) + "00" : null;
      this.data.reset_time = resetTimeHour;
      return;
    },
    initailDataFormating(fetchData) {
      fetchData.start_number = typeof fetchData.start_number === 'string' ? Number(fetchData.start_number) : fetchData.start_number;
      return fetchData;
    },
    changeEditStatus(event) {
      console.log("changeEditStatus event: ", event);
      let editDataIndex = this.editList.findIndex(d => d.code == event.code);
      if (event.warning) {
        if (editDataIndex == -1) {
          this.editList.push(event);
        } else {
          let editData = this.editList.find(d => d.code == event.code);
          Object.assign(editData, event);
        }
      } else {
        if (editDataIndex != -1) {
          this.editList.splice(editDataIndex, 1);
        }
      }
    }
  },
  watch: {
    editList: function(newVal, oldVal) {
      console.log("editList newVal: ", newVal);
      if (newVal.length > 0) {
        let editStatusData = {
          value: this.value
        };
        this.$emit("edit-status", editStatusData);
      } else {
        let savedStatusData = {
          value: this.value
        };
        this.$emit("saved-status", savedStatusData);
      }
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
